import axios from 'axios';

const api = axios.create({
  baseURL: '/vaal-search',
  headers: {
    'Content-Type': 'application/json'
  },
});

export { api };